import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api from "../../request";

const HotStepperMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await api.get("dashboard/hot-stepper-messages");
        setMessages(res.data.messages || []);
      } catch (error) {
        console.error("Error fetching hot stepper messages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  if (loading) {
    return <div className="text-center text-gray-500">Loading messages...</div>;
  }

  return (
    <div className="bg-white shadow rounded-xl p-6 mt-8">
      <div className="flex items-center gap-2 mb-4">
        <Bell className="text-primary" size={20} />
        <h3 className="text-lg font-semibold">Messages from Your Hot Steppers</h3>
      </div>
      {messages.length > 0 ? (
        <ul className="space-y-3">
          {messages.map((msg) => (
            <li key={msg.id} className="text-sm border-l-4 pl-3 border-primary">
              {msg.content}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-500">No messages yet from your Hot Steppers.</p>
      )}
    </div>
  );
};

export default HotStepperMessages;
